module.exports = __webpack_public_path__ + "75018a80ec1ca2b02b9ec3ace58dec39.MP3";